export {
  default as checkRounded,
  ReactComponent as CheckRounded,
} from '@assets/icons/material/check_rounded_24px.svg'    
